import React from 'react';
import TextField, { InputModeType, InputType } from '@jbhi-fi/lanyard-ui/components/TextField';

export type EmailInputPropsType = {
  className?: string;
  errorMsg?: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  hasError: boolean;
};

export const EmailInput = ({ errorMsg, value, onChange, hasError }: EmailInputPropsType): JSX.Element => {
  return (
    <TextField
      id="email-input"
      name="email-input"
      type={InputType.email}
      inputMode={InputModeType.email}
      label="Email address"
      errorMsg={errorMsg}
      hasError={hasError}
      onChange={onChange}
      value={value}
    />
  );
};
